export default __webpack_public_path__ + "swiper-shadow-left0b0f92.png";